"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationHelper = void 0;
var lodash_1 = __importDefault(require("lodash"));
var models_1 = require("../models");
exports.TranslationHelper = {
    initializeEditItemForCultureCode: function (culture) {
        var editItem = {
            cultureCode: culture.cultureCode,
            text: '',
            cultureName: culture.displayName,
            editState: models_1.EditState.None,
        };
        return editItem;
    },
    initializeEditableTranslationItems: function (defaultCultureCode, availableCultures, supportedCultures) {
        var translations = this.initializeTranslationItems(supportedCultures, availableCultures);
        return this.getEditableTranslations(translations, defaultCultureCode);
    },
    initializeTranslationItems: function (supportedCultures, availableCultures) {
        var translations = [];
        supportedCultures.forEach(function (cultureCode) {
            var culture = availableCultures.find(function (c) { return c.name === cultureCode; });
            if (culture !== undefined) {
                var editItem = {
                    cultureCode: cultureCode,
                    text: '',
                    cultureName: culture.displayText,
                    editState: models_1.EditState.None,
                };
                translations.push(editItem);
            }
        });
        return lodash_1.default.orderBy(translations, 'cultureName');
    },
    hasTranslationByCultureCode: function (cultureCode, translations) {
        return lodash_1.default.filter(translations, function (t) { return t.cultureCode === cultureCode; }).length > 0;
    },
    getTranslationByCultureCode: function (cultureCode, translations) {
        var translation = lodash_1.default.find(translations, function (t) { return t.cultureCode === cultureCode; });
        if (!translation) {
            return '';
        }
        return translation.text;
    },
    getEditableTranslations: function (translations, defaultCultureCode) {
        var editableTranslations = lodash_1.default.reject(translations, function (t) { return t.cultureCode === defaultCultureCode; });
        return __spreadArray([], editableTranslations, true);
    },
    getCountOfSupportedCultures: function (defaultCultureCode, supportedCultures) {
        var supportedLanguagesOtherThanDefault = lodash_1.default.reject(supportedCultures, function (c) { return c === defaultCultureCode; });
        return supportedLanguagesOtherThanDefault.length;
    },
    getCountOfTranslations: function (translations) {
        var translationsWithValues = lodash_1.default.filter(translations, function (t) { return t.text !== null && t.text !== ''; });
        return translationsWithValues.length;
    },
    mapHTMLToTranslationData: function (translations, html) {
        var modifiedTranslations = lodash_1.default.orderBy(lodash_1.default.cloneDeep(translations), ['cultureCode']);
        var cultureCodes = lodash_1.default.map(modifiedTranslations, function (t) { return t.cultureCode; });
        var incomingDocument = document.createElement('html');
        incomingDocument.innerHTML = html;
        var rows = incomingDocument.getElementsByTagName('tr');
        if (rows.length === 0) {
            return [];
        }
        for (var i = 0; i <= rows.length; i++) {
            var row = rows[i];
            if (!row || !row.children || row.children.length < 2) {
                continue;
            }
            var cultureCode = row.children[0].textContent || '';
            var textValue = row.children[1].textContent || '';
            var index = cultureCodes.indexOf(cultureCode);
            if (index > -1) {
                // TODO: any validation on text value? pure extract from clipboardData
                modifiedTranslations[index].text = textValue;
            }
        }
        return modifiedTranslations;
    },
    updateTranslationEditState: function (nextTranslations, originalTranslations) {
        var orderedNextTranslations = lodash_1.default.orderBy(nextTranslations, function (t) { return t.cultureCode; });
        var orderedOriginalTranslations = lodash_1.default.orderBy(originalTranslations, function (t) { return t.cultureCode; });
        var result = lodash_1.default.map(orderedNextTranslations, function (t, index) {
            var originalTranslation = orderedOriginalTranslations[index];
            var editState = exports.TranslationHelper.getEditState(t, originalTranslation);
            return __assign(__assign({}, t), { editState: editState });
        });
        return lodash_1.default.orderBy(result, ['cultureName', 'cultureCode']);
    },
    getEditState: function (translation, originalTranslation) {
        return originalTranslation.text === translation.text
            ? models_1.EditState.None
            : originalTranslation.text === '' && translation.text !== ''
                ? models_1.EditState.Add
                : originalTranslation.text !== '' && translation.text === ''
                    ? models_1.EditState.Remove
                    : models_1.EditState.Update;
    },
};
